// extracted by mini-css-extract-plugin
export default {"parentWrapper":"auth_parentWrapper__CISuj","formHeader":"auth_formHeader__bw5wa"};